import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import TrendingItem from './TrendingItem'
import styled from 'styled-components'
import { AiOutlineEdit } from 'react-icons/ai'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

const TrendingListBox = styled.div`
  display: flex;
  margin-left: 10px;
  margin-right: 10px;
  overflow-x: auto;
  ::-webkit-scrollbar {
    display: none;
  }
`
const Edit = styled.span`
  margin-left: 15px;
  font-size: 15px;
  &:hover {
    cursor: pointer;
    color: #ff4500;
    font-weight: bold;
  }
`
const TrendingList = props => {
  // useEffect(() => {
  //   console.log(props.trendingList)
  // }, [])

  const history = useHistory()

  const clickImg = (
    cardInfo,
    packageId,
    lightColor,
    darkColor,
    mainId,
    mainImg
  ) => {
    props.clickImg(cardInfo, packageId, lightColor, darkColor, mainId, mainImg)
  }

  const Scroll = e => {
    const list = document.getElementById('trending')
    list.scrollLeft += e.deltaY
  }

  const [dragging, setDragging] = useState(false)
  const [startX, setStartX] = useState()

  const Drag = e => {
    const list = document.getElementById('trending')
    e.preventDefault()
    setDragging(true)
    setStartX(e.pageX + list.scrollLeft)
  }
  const Move = e => {
    const list = document.getElementById('trending')
    if (dragging) {
      list.scrollLeft = startX - e.pageX
    }
  }
  const DragEnd = () => {
    setDragging(false)
  }

  return (
    <div>
      <section
        className="content-header"
        style={{
          marginBottom: '20px',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          color: !props.mode ? 'black' : 'white',
        }}
      >
        <h1>이번주 BEST 이모티콘</h1>
        <OverlayTrigger
          placement="right"
          overlay={<Tooltip>Go to Curation page (Type A)</Tooltip>}
        >
          <Edit
            onClick={() =>
              history.push({
                pathname: '/Curation',
                state: {
                  pageNumber: 1,
                  type: 'A',
                  lang: props.trendingList ? props.trendingList.language : 'en',
                  country: props.trendingList
                    ? props.trendingList.country
                    : 'us',
                },
              })
            }
          >
            <AiOutlineEdit size={24} />
          </Edit>
        </OverlayTrigger>
      </section>
      <section
        onWheel={Scroll}
        onMouseDown={Drag}
        onMouseMove={Move}
        onMouseUp={DragEnd}
        onMouseLeave={DragEnd}
      >
        <TrendingListBox id="trending">
          {props.trendingList && props.trendingList.card ? (
            props.trendingList.card.map((item, index) => (
              <TrendingItem
                key={index}
                cardInfo={props.trendingList}
                packageId={item.packageId}
                stickerId={item.stickerId}
                stickerImg={item.stickerImg}
                lightColor={item.lightBackgroundCode}
                darkColor={item.darkBackgroundCode}
                clickImg={clickImg}
                mode={props.mode}
              />
            ))
          ) : (
            <TrendingListBox>데이터가 없습니다.</TrendingListBox>
          )}
        </TrendingListBox>
      </section>
    </div>
  )
}

export default TrendingList
